cv.PublicView = Marionette.LayoutView.extend({
  el: "#content",

  regions: {},

  childEvents: {
    // This callback will be called whenever a child is rendered or emits a `render` event
    show: function (view) {
      this.updateStyles();
    },
    render: function () {
      this.updateStyles();
    },
  },

  events: {
    "click .nav--top .nav__links a": "selectSection",
    "click .hide-preview-banner": "hidePreviewBanner",
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    // Set some variables
    this.is_scrolling = false;
    this.prev_scroll_position = 0;
    this.campaign_id = 0;
    this.project_id = 0;
    this.post_id = 0;
    this.team_id = 0;
    if ($("#cv-campaign-id").length > 0) {
      this.page_type = "campaign";
      this.campaign_id = $("#cv-campaign-id").val();
    }
    if ($("#cv-project-id").length > 0) {
      this.page_type = "project";
      this.project_id = $("#cv-project-id").val();
    }
    if ($("#cv-post-id").length > 0) {
      this.page_type = "post";
      this.post_id = $("#cv-post-id").val();
    }
    if ($("#cv-team-id").length > 0) {
      this.page_type = "team";
      this.team_id = $("#cv-team-id").val();
    }

    // Map sections
    this.fixed = false;
    this.last_id = null;
    this.scroll_items = this.$(".nav__links a").map(function () {
      if ($(this).attr("href").substr(0, 1) == "#") {
        var item = $($(this).attr("href"));
        if (item.length) {
          return item;
        }
      }
    });

    // Check for scrolling events
    $(window).on("scroll", _.throttle(_.bind(this.checkNav, this), 25));
    this.checkNav();

    // Other events
    // If we are in the editor the fire the loaded
    if (window.name == "cv_editor") {
      window.setInterval(
        _.bind(function () {
          this.updateStyles();
        }, this),
        500,
      );
    }

    // Bind regions
    this.bindRegions();

    // Update any custom styles
    this.updateStyles();

    // Bind images
    this.bindImgix();

    // Pipe analytics data to Keen
    // HACK: if we aren't in login or search or preview, then track the view
    if (location.pathname != "/login" && location.pathname != "/search") {
      if (!_.has(cv.PRELOADED, "preview")) {
        this.trackView();
      }
    }

    // Trigger behavior stuff
    vent.trigger("public:initialized");

    console.log("PublicView initialized");
  },

  templateHelpers: function () {
    return {};
  },

  trackView: function () {
    // If we have an undefined Keen object (due to script blocked or whatever)
    if (typeof Keen === "undefined") {
      return false;
    }

    Keen.ready(
      _.bind(function () {
        // Instantiate the client
        keen_client = new Keen({
          projectId: keen_project_id,
          writeKey: keen_write_key,
        });

        // Session cookie (25 minutes)
        var session_expire = new Date(new Date().getTime() + 25 * 60 * 1000);
        var session_id = Cookies.get("session_cookie");
        if (_.isUndefined(session_id)) {
          session_id = Math.uuid(32);
          Cookies.set("session_cookie", session_id, { expires: session_expire });
        }

        // Permanent Cookie
        var permanent_tracker = Cookies.get("permanent_cookie");
        if (_.isUndefined(permanent_tracker)) {
          permanent_tracker = Math.uuid(32);
          Cookies.set("permanent_cookie", permanent_tracker);
        }

        // Record an event
        var data = {
          title: document.title,
          page_url: window.location.href,
          referrer: document.referrer,
          session_id: session_id,
          permanent_tracker: permanent_tracker,
          ip_address: "${keen.ip}",
          user_agent: "${keen.user_agent}",
          organization: {
            id: cv.campaign.get("organization.id"),
          },
          campaign: {
            id: cv.campaign.get("id"),
          },
          keen: {
            addons: [
              {
                name: "keen:url_parser",
                input: {
                  url: "page_url",
                },
                output: "parsed_page_url",
              },
              {
                name: "keen:referrer_parser",
                input: {
                  referrer_url: "referrer",
                  page_url: "page_url",
                },
                output: "referrer.info",
              },
              {
                name: "keen:ip_to_geo",
                input: {
                  ip: "ip_address",
                },
                output: "ip_geo_info",
              },
              {
                name: "keen:ua_parser",
                input: {
                  ua_string: "user_agent",
                },
                output: "parsed_user_agent",
              },
            ],
          },
        };
        if (this.project_id != 0) {
          data["project"] = {
            id: this.project_id,
          };
        }
        if (this.team_id != 0) {
          data["team"] = {
            id: this.team_id,
          };
        }
        if (this.post_id != 0) {
          data["post"] = {
            id: this.post_id,
          };
        }
        keen_client.recordEvent("pageviews", data);
      }, this),
    );
  },

  hidePreviewBanner: function (e) {
    e.preventDefault();

    this.$(".preview-banner").remove();
  },

  bindRegions: function () {
    if (this.$("#auth").length > 0) {
      this.addRegions({ auth: "#auth" });
    }

    if (this.$("#setup").length > 0) {
      this.addRegions({ setup: "#setup" });
    }

    if (this.$("#pay").length > 0) {
      this.addRegions({ pay: "#pay" });
    }

    if (this.$("#main").length > 0) {
      this.addRegions({ main: "#main" });
      this.main.attachView(new cv.PublicMainView());
    }

    if (this.$("#search").length > 0) {
      this.addRegions({ search: "#search" });
    }

    if (this.$("#members").length > 0) {
      this.addRegions({ members: "#members" });
      this.showChildView(
        "members",
        new cv.PublicMembersView({
          heading: this.$("#members h2").length > 0 ? this.$("#members h2").html() : "",
          subheading: this.$("#members h3").length > 0 ? this.$("#members h3").html() : "",
          collection: new cv.ProjectsNew(null, {
            params: {
              api_key: cv.PRELOADED.public_api_key,
              team_id: $("#cv-team-id").val(),
              sort: "display_funds_raised",
              order: "desc",
              limit: 10,
            },
          }),
        }),
      );
    }

    if (this.$("#fundraisers").length > 0) {
      this.addRegions({ fundraisers: "#fundraisers" });
      this.showChildView(
        "fundraisers",
        new cv.PublicFundraisersView({
          heading: this.$("#fundraisers h2").length > 0 ? this.$("#fundraisers h2").html() : "",
          subheading: this.$("#fundraisers h3").length > 0 ? this.$("#fundraisers h3").html() : "",
        }),
      );
    }

    if (this.$("#posts").length > 0) {
      this.addRegions({ posts: "#posts" });
      this.showChildView(
        "posts",
        new cv.PublicPostsView({
          heading: this.$("#posts h2").length > 0 ? this.$("#posts h2").html() : "",
          subheading: this.$("#posts h3").length > 0 ? this.$("#posts h3").html() : "",
          collection: new cv.Posts(null, {
            params: {
              api_key: cv.PRELOADED.public_api_key,
              project_id: $("#cv-project-id").length > 0 ? $("#cv-project-id").val() : null,
              team_id: $("#cv-team-id").length > 0 ? $("#cv-team-id").val() : null,
              filters: ["status:eq:1"],
              limit: $("#cv-project-id").length > 0 ? 4 : 4,
            },
          }),
        }),
      );
    }

    if (this.$("#donors").is(":visible")) {
      this.addRegions({ donors: "#donors" });
      this.showChildView(
        "donors",
        new cv.PublicPledgesView({
          page_type: this.page_type,
          collection: new cv.Pledges(null, {
            params: {
              api_key: cv.PRELOADED.public_api_key,
              project_id: $("#cv-project-id").length > 0 ? $("#cv-project-id").val() : null,
              team_id: $("#cv-team-id").length > 0 ? $("#cv-team-id").val() : null,
              show_donations: true,
              show_pledges: true,
              order: "desc",
              limit: 15,
            },
          }),
        }),
      );
    }

    /* if (this.$("#pledges").is(":visible")) {
      this.addRegions({ pledges: "#pledges" });
      this.showChildView(
        "pledges",
        new cv.PublicPledgesView({
          page_type: this.page_type,
          collection: new cv.Pledges(null, {
            params: {
              api_key: cv.PRELOADED.public_api_key,
              project_id: $("#cv-project-id").length > 0 ? $("#cv-project-id").val() : null,
              team_id: $("#cv-team-id").length > 0 ? $("#cv-team-id").val() : null,
              limit: 15,
            },
          }),
        })
      );
    } */
  },

  bindImgix: function () {
    if (this.$("#hero").length > 0) {
      imgix.fluid(this.$("#hero").get(0), {
        rootNode: this.$("#hero").get(0),
        autoInsertCSSBestPractices: true,
      });
    }

    if (this.$("#project-stats").length > 0) {
      imgix.fluid(this.$("#project-stats").get(0), {
        rootNode: this.$("#project-stats").get(0),
        autoInsertCSSBestPractices: true,
      });
    }

    if (this.$("#details").length > 0) {
      imgix.fluid(this.$("#details").get(0), {
        rootNode: this.$("#details").get(0),
        autoInsertCSSBestPractices: true,
      });
    }

    if (this.$("#main").length > 0) {
      imgix.fluid(this.$("#main").get(0), {
        rootNode: this.$("#main").get(0),
        autoInsertCSSBestPractices: true,
      });
    }
  },

  selectSection: function (e) {
    // HACK: if we are in a preview then disable section clicks
    if (_.has(cv.PRELOADED, "preview")) {
      e.preventDefault();
      return false;
    }

    if ($(e.currentTarget).attr("href").substr(0, 1) != "#") {
      return true;
    }

    e.preventDefault();

    this.is_scrolling = true;
    $("body").addClass("is-scrolling-down");

    if ($(e.currentTarget).attr("href") == "#home") {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        100,
      );
    } else {
      $("html, body").animate(
        {
          scrollTop: $($(e.currentTarget).attr("href")).offset().top - 59,
        },
        100,
      );
    }

    // Reset this after the scroll is done
    setTimeout(
      _.bind(function () {
        this.is_scrolling = false;
        $("body").addClass("is-scrolling-down");
      }, this),
      500,
    );
  },

  checkNav: function () {
    // Get the scrollTop
    var scrollTop = $(window).scrollTop();

    if (this.is_scrolling == false) {
      if (scrollTop > this.prev_scroll_position && scrollTop >= 90) {
        $("body").addClass("is-scrolling-down");
      } else {
        $("body").removeClass("is-scrolling-down");
      }
    }

    // Add the fixed class to the nav bar after it passes the navigation
    if (this.$(".nav--top").length > 0) {
      if (scrollTop > this.prev_scroll_position && scrollTop > this.$(".nav-line").offset().top) {
        this.$(".nav-line").addClass("nav-line--fixed");
        this.$(".nav--top").addClass("nav--fixed");

        // Move the stats area behind the nav bar
        this.$("#project-stats .widget").css("z-index", 3);
      }
      if (
        scrollTop < this.prev_scroll_position &&
        scrollTop < this.$(".nav-line").offset().top - 60
      ) {
        this.$(".nav-line").removeClass("nav-line--fixed");
        this.$(".nav--top").removeClass("nav--fixed");

        // Move the stats area back to normal place
        this.$("#project-stats .widget").css("z-index", 5);
      }
    }

    if (scrollTop >= 90) {
      $("body").addClass("is-scrolling");
    } else {
      $("body").removeClass("is-scrolling");
    }

    this.prev_scroll_position = scrollTop;

    // Get id of current scroll item
    var cur = this.scroll_items.map(function () {
      // If we are scrolling into the container then add it
      if (scrollTop + 65 > $(this).offset().top) return this;
    });

    // Get the id of the current element
    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : "";

    if (this.last_id !== id) {
      this.last_id = id;

      // Set/remove active class
      this.$(".nav--top .nav__links a").removeClass("active");
      // If we aren't in a section, then choose the first one
      if (id == "") {
        if (this.post_id != 0) {
          this.$('.nav--top .nav__links a[href="#main"]').addClass("active");
        } else {
          this.$(".nav--top .nav__links a:eq(0)").addClass("active");
        }
      } else {
        this.$(".nav--top .nav__links a")
          .filter("[href='#" + id + "']")
          .addClass("active");
      }
    }
    if (this.post_id == 0) {
      if (scrollTop + $(window).height() == $(document).height()) {
        this.$(".nav--top .nav__links a").removeClass("active");
        this.$(".nav--top .nav__links a:last-child").addClass("active");
      }
    }
  },

  updateStyles: function () {
    // Change the color based on the background colors
    _.each(
      this.$("[data-color]"),
      function (el) {
        var el_to_calculate = $(el).data("color");
        if (el_to_calculate == "self") {
          var text_color_class = cv.idealTextColor(this.$(el).css("background-color"));
        } else {
          var text_color_class = cv.idealTextColor(this.$(el_to_calculate).css("background-color"));
        }
        this.$(el).addClass(text_color_class);
      },
      this,
    );
  },
});
